module.exports = __webpack_public_path__ + "img/03@2x.23106e77.png";